import { Component, Input } from '@angular/core';
import { PopoverComponent } from '../../../core/modules/application-list/popover/popover.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-nav-item',
    standalone: true,
    imports: [CommonModule, PopoverComponent],
    templateUrl: './nav-item.component.html',
    styleUrl: './nav-item.component.scss'
})
export class NavItemComponent {
    @Input({ required: true }) label: string = "";
    @Input() usePopover: boolean = false;
    @Input() selected: boolean = false;

    get ngStyle() {
        if (this.selected) {
            return { "background-color": "#6badef" };
        }
        return { "background-color": "transparent" };
    }


    get pNgStyle() {
        if (this.selected) {
            return { "color": "#6badef" };
        }
        return {}
    }
}
